import { color } from 'echarts';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Counter from '@/shared/components/ui/Counter/Counter';
import { useColorStore } from '@/store/colorStore';
import { useSettingsStore } from '@/store/useSettingsStore';

interface CardInOutProps {
  title: string;
  typeCard?: 'incoming' | 'outgoing';
  totalVolume: number;
  totalSpeed: number;
}

const CardInOut = ({ typeCard = 'incoming', title, totalVolume, totalSpeed }: CardInOutProps) => {
  const { NEWCOLOR } = useColorStore();
  const { t } = useTranslation();
  const counterAnimationEnabled = useSettingsStore((state) => state.counterAnimationEnabled);

  const Icon = typeCard === 'incoming' ? ArrowRight : ArrowLeft;
  const colorIcon = typeCard === 'incoming' ? NEWCOLOR.bluePrimary : NEWCOLOR.greenPrimary;

  const renderTotalVolume = () => {
    if (counterAnimationEnabled && typeof totalVolume === 'number') {
      return <Counter value={totalVolume} />;
    }
    return totalVolume;
  };
  const renderTotalSpeed = () => {
    if (counterAnimationEnabled && typeof totalSpeed === 'number') {
      return <Counter value={totalSpeed} />;
    }
    return totalSpeed;
  };

  return (
    <div className="flex flex-col gap-6 w-full rounded-[12px] border p-3 shadow-[0_4px_4px_0_rgba(0,0,0,0.16)] dark:bg-[#F3F6FE]/10">
      <div className="inline-flex gap-3 items-center">
        {typeCard === 'incoming' ? (
          <>
            <span className="title2">{title}</span>
            <Icon size={18} color={colorIcon} />
          </>
        ) : (
          <>
            <Icon size={18} color={colorIcon} />
            <span className="title2">{title}</span>
          </>
        )}
      </div>

      <div className="flex flex-row flex-wrap gap-3 items-baseline">
        <div className="flex flex-col gap-[2.5px]">
          <span className="title2 uppercase">volume</span>
          <span className="title2bold">{renderTotalVolume()}</span>
        </div>
        <div className="flex flex-col">
          <span className="title2 uppercase">{t('traffic>master>avg speed')}</span>
          <span className="title2bold">
            {totalSpeed} <span className="title2">km/h</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardInOut;
